export default __webpack_public_path__ + "static/media/046.f13198bd.png";